import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordEmailFormViewCmsKey =
    | 'emailPlaceholder'
    | 'pleaseEnterEmail'
    | 'furtherInstructions'
    | 'btnResetPassword';

export const ForgotPasswordEmailFormViewCmsWithDefault: CmsObjectWithDefault<ForgotPasswordEmailFormViewCmsKey> = {
    emailPlaceholder: {
        cmsId: 67374,
        defaultTranslation: 'Email',
    },
    pleaseEnterEmail: {
        cmsId: 76311,
        defaultTranslation: 'Please enter your email in the box above.',
    },
    furtherInstructions: {
        cmsId: 76312,
        defaultTranslation: 'We will send you a link to access further instructions.',
    },
    btnResetPassword: {
        cmsId: 76313,
        defaultTranslation: 'Reset Password',
    },
};
